var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8789 3.33938L12.6583 1.11882C12.3071 0.767683 11.695 0.767683 11.3432 1.11882L10.8063 1.65578L14.3425 5.19143L14.8789 4.65508C15.0547 4.47921 15.1511 4.24551 15.1511 3.99694C15.1511 3.74834 15.0547 3.51464 14.8789 3.33938ZM0.869247 14.7454C0.838175 14.8535 0.868018 14.9704 0.948168 15.0505C1.00721 15.1096 1.08675 15.1413 1.16818 15.1413C1.19616 15.1413 1.22474 15.1375 1.25333 15.1295L5.42786 13.9368L2.06251 10.5709L0.869247 14.7454ZM5.95204 13.5815L2.41641 10.0458L10.3671 2.09516L13.9027 5.6308L5.95204 13.5815Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b38aed7798f89669020225369259a834.svg";
export { ForwardRef as ReactComponent };